import PropTypes from 'prop-types';
import { Tooltip, makeStyles } from '@material-ui/core';

import BitIcon from './assets/small-bha/bit.svg';
import PdmIcon from './assets/small-bha/pdm.svg';
import RssIcon from './assets/small-bha/rss.svg';
import StabilizerIcon from './assets/small-bha/stabilizer.svg';
import NonMagIcon from './assets/small-bha/non-mag.svg';

const TileTooltip = {
  bit: 'Bit',
  other: 'Non Magnetic',
  pdm: 'PDM',
  rss: 'Rotary Steerables',
  stabilizer: 'Stabilizer',
  ags: 'AGS',
};

const useStyles = makeStyles({
  iconWrapper: {
    width: ({ width }) => width,
    height: ({ height }) => height,
  },
  tileIcon: {
    width: '100%',
    height: '100%',
  },
});

function BHATileIcon({ component, width, height }) {
  const { family, material } = component;
  const classes = useStyles({ width, height });

  let icon;
  if (family === 'bit') {
    icon = BitIcon;
  } else if (family === 'pdm') {
    icon = PdmIcon;
  } else if (family === 'rss') {
    icon = RssIcon;
  } else if (family === 'stabilizer') {
    icon = StabilizerIcon;
  } else if (family === 'ags') {
    icon = StabilizerIcon;
  } else if (family === 'other' || material === 'Non Magnetic') {
    icon = NonMagIcon;
  } else {
    icon = NonMagIcon;
  }

  return (
    <Tooltip title={TileTooltip[family] || TileTooltip.other} placement="bottom">
      <div className={classes.iconWrapper}>
        <img src={icon} className={classes.tileIcon} alt={family} />
      </div>
    </Tooltip>
  );
}

BHATileIcon.propTypes = {
  width: PropTypes.string.isRequired,
  height: PropTypes.number.isRequired,
  component: PropTypes.shape({
    family: PropTypes.string,
    material: PropTypes.string,
    bit_type: PropTypes.string,
  }).isRequired,
};

export default BHATileIcon;
